'use strict';

var _ = require('lodash');
var FaresOptimizerWebFareChart = function FaresOptimizerWebFareChart(AbstractChart, chartSimpleLine, chartXAxis, chartYAxis, chartConstants) {
  var chartParams = require('./Params');
  var chartScales = require('./Scales');
  var Chart = function Chart(container, scope) {
    var self = this;
    AbstractChart.call(this, container, scope.chartFormatters);
    var simpleLine = chartSimpleLine('departureDate', 'fareToPlot', 'step-after', scope.chartFormatters.tooltipFormatter);
    var xAxis = chartXAxis(undefined, scope.chartFormatters.xAxisTickValues);
    var yAxisLeft = chartYAxis(scope.chartFormatters.yAxisTickFormatter, chartConstants.AXIS.MODE.LEFT);
    var yAxisRight = chartYAxis(scope.chartFormatters.yAxisTickFormatter, chartConstants.AXIS.MODE.RIGHT);
    self.render = function (data) {
      this.initChart(data, undefined, chartParams);
      this.scales = chartScales(this.params, data);
      this.callForDataGroup([yAxisLeft, yAxisRight, simpleLine, xAxis], this.scales);
    };
  };
  Chart.prototype = Object.create(AbstractChart.prototype);
  Chart.constructor = Chart;
  return Chart;
};
FaresOptimizerWebFareChart.$inject = ['AbstractProfileChart', 'ChartElementsSimpleLineWithTooltip', 'ChartElementsXAxis', 'ChartElementsYAxis', 'ChartElementsConstants'];
module.exports = FaresOptimizerWebFareChart;